import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const QuickActions = ({ onAction }) => {
  const navigate = useNavigate();
  const actions = [
    {
      id: 'add-contributor',
      title: 'Add Contributor',
      description: 'Create new contributor account',
      icon: 'UserPlus',
      color: 'var(--color-primary)',
      action: 'addContributor'
    },
    {
      id: 'create-gallery',
      title: 'Create Gallery',
      description: 'Start a new gallery project',
      icon: 'Plus',
      color: 'var(--color-success)',
      action: 'createGallery'
    },
    {
      id: 'drive-settings',
      title: 'Drive Settings',
      description: 'Configure Google Drive integration',
      icon: 'Settings',
      color: 'var(--color-accent)',
      action: 'driveSettings'
    },
    {
      id: 'export-data',
      title: 'Export Analytics',
      description: 'Download visitor and gallery data',
      icon: 'Download',
      color: 'var(--color-warning)',
      action: 'exportData'
    }
  ];

  const handleActionClick = (action) => {
    if (typeof action === 'function') {
      action();
    } else {
      onAction(action);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {actions?.map((action) => (
        <button
          key={action?.id}
          onClick={() => handleActionClick(action?.action)}
          className="bg-card rounded-xl p-4 md:p-6 border border-border text-left hover:shadow-warm-md smooth-transition hover-lift"
        >
          <div 
            className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
            style={{ backgroundColor: `${action?.color}15` }}
          >
            <Icon name={action?.icon} size={24} color={action?.color} />
          </div>
          <h3 className="text-base font-semibold mb-1">{action?.title}</h3>
          <p className="text-xs text-muted-foreground">{action?.description}</p>
        </button>
      ))}
    </div>
  );
};

export default QuickActions;